import React, { useState } from 'react';
import Page from 'framework7-react/components/page';
import { Router } from 'framework7/modules/router/router';
import { useTranslation } from 'react-i18next';

import { Store } from 'store';
import { Button, Option } from 'components';

import './SettingsFAQ.less';
import aituBridge from "@btsd/aitu-bridge";
import BackButton from "../../assets/BackButton";

interface IProps {
  $f7router: Router.Router;
}

const FAQ_RU: React.FC = () => (
  <>
    <p className="quiz-faq-question">Как участвовать в Quizes?</p>
    <p className="quiz-faq-answer">
      Зайдите в мини-приложение "Quizes" и ознакомьтесь с правилами участия.
    </p>

    <p className="quiz-faq-question">Сколько вопросов и ответов?</p>
    <p className="quiz-faq-answer">
      В каждой есть определенное количество вопросов, на каждый из которых есть
      несколько вариантов ответа. Количество вопросов указывается в начале
      Quiz-а.
    </p>

    <p className="quiz-faq-question">Есть ли у меня право на ошибку?</p>
    <p className="quiz-faq-answer">
      Вы можете ошибаться и продолжать играть, но чем больше ошибок - тем меньше
      баллов.
    </p>

    <p className="quiz-faq-question">Как пригласить друга?</p>
    <p className="quiz-faq-answer">
      Для того чтобы позвать друга, нужно зайти в приложение Quizes и нажать на
      кнопку "Попытки", в появившемся окне нужно скопировать промокод или ссылку
      и поделиться им со своим другом. Ваш друг введет данный промокод при
      регистрации и у вас появится дополнительная жизнь.
    </p>

    <p className="quiz-faq-question">Сколько друзей я могу пригласить?</p>
    <p className="quiz-faq-answer">
      Вы можете приглашать неограниченное количество друзей и получать за каждое
      приглашение одну "жизнь".
    </p>

    <p className="quiz-faq-question">Сколько длится один вопрос?</p>
    <p className="quiz-faq-answer">
      Один вопрос длится 25 секунд и дает 5 баллов, каждые 5 секунд у вас
      отнимается 1 балл, поэтому постарайтесь отвечать на вопросы как можно
      быстрее.
    </p>

    <p className="quiz-faq-question">Могу ли я менять выбранный ответ?</p>
    <p className="quiz-faq-answer">
      Вы можете менять выбранный ответ до истечения времени. Поданным считается
      ответ, выбранный на момент истечения времени или после нажатия кнопки
      "Ответить".
    </p>

    <p className="quiz-faq-question">Могу ли я играть с двух аккаунтов?</p>
    <p className="quiz-faq-answer">
      Нет. Один участник участвует в одной и той же Викторине не более 1-го
      раза.
    </p>

    <p className="quiz-faq-question">Где я увижу свой результат?</p>
    <p className="quiz-faq-answer">
      После окончания вы увидите результаты правильных ответов и набранных
      баллов, также вы можете увидеть список лидеров, где размещены пользователи
      с наивысшими баллами по этому Quiz-у.
    </p>

    <p className="quiz-faq-question">Что мне делать с набранными баллами?</p>
    <p className="quiz-faq-answer">
      Проходите регулярные вопрос-ответы и копите баллы. В скором времени будет
      возможность обменять их на призы.
    </p>
  </>
);

const FAQ_KK: React.FC = () => (
  <>
    <p className="quiz-faq-question">Quiz-ға қалай қатысуға болады?</p>
    <p className="quiz-faq-answer">
      "Aitu Викториналары" ықшам қолданбасына кіріп, қатысу ережелерімен
      танысыңыз. Тікелей эфирдегі әр викторинаның белгілі шарттары бар.{" "}
    </p>

    <p className="quiz-faq-question">Quiz-да қанша сұрақ болады?</p>
    <p className="quiz-faq-answer">
      Әр Quiz белгілі сұрақ саны болады, олардың әр қайсысының бірнеше жауап
      нұсқасы бар. Сұрақтардың саны басында көрсетіледі.{" "}
    </p>

    <p className="quiz-faq-question">Қате жасауға бола ма?</p>
    <p className="quiz-faq-answer">
      Ия, қате жасап, ойынды жалғастыра беруге болады, алайда қате саны көп
      болған сайын балл саны аз болады.{" "}
    </p>

    <p className="quiz-faq-question">Досымды қалай шақыруға болады?</p>
    <p className="quiz-faq-answer">
      Досыңызды шақыру үшін Quiz қолданбасына кіріп, "Мүмкіндіктер" түймешігіне
      басыңыз да, ашылған терезедегі промокодты не сілтемені көшіріп алып,
      досыңызбен бөлісіңіз. Досыңыз осы промокодты тіркелу кезінде енгізгенде,
      Сізде қосымша "жан" пайда болады.{" "}
    </p>

    <p className="quiz-faq-question">Қанша досымды шақыруға болады?</p>
    <p className="quiz-faq-answer">
      Шексіз достар санын шақырып, әр шақырылған досыңыз үшін бір "жан"
      алуыңызға болады.{" "}
    </p>

    <p className="quiz-faq-question">Бір сұрақ қанша уақыт жалғасады?</p>
    <p className="quiz-faq-answer">
      Бір сұраққа 25 секунд және 5 балл беріледі, әр 5 секунд сайын сізден 1
      балл шегеріледі, сондықтан сұрақтарға барынша тез жауап беруге тырысыңыз.{" "}
    </p>

    <p className="quiz-faq-question">Таңдалған жауапты өзгерте аламын ба?</p>
    <p className="quiz-faq-answer">
      Уақыт аяқталғанша таңдалған жауапты өзгертуге болады. Уақыт аяқталғанда
      таңдалған немесе "Жауап беру" түймешігі басылғаннан кейінгі жауап
      қабылданады.{" "}
    </p>

    <p className="quiz-faq-question">Екі аккаунттан ойнауға бола ма?</p>
    <p className="quiz-faq-answer">
      Жоқ. Бір қатысушы бір Викторинаға 1 реттен артық қатыса алмайды.
    </p>

    <p className="quiz-faq-question">Өз нәтижемді қайдан көре аламын?</p>
    <p className="quiz-faq-answer">
      Quiz аяқталған соң дұрыс жауап нәтижелері мен жиналған балл санын көресіз,
      сондай-ақ сол quiz бойынша ең жоғары балл санын жинаған пайдаланушылары
      бар көшбасшылар тізімін көре аласыз.{" "}
    </p>

    <p className="quiz-faq-question">Жиналған балдармен не істей аламын?</p>
    <p className="quiz-faq-answer">
      Жүйелі quiz-дардан өтіп, балл жинаңыз. Жақында оларды жүлделерге
      ауыстыруға мүмкіндік болады.{" "}
    </p>
  </>
);

const languageMap: { [lng: string]: React.FC } = {
  ru: FAQ_RU,
  kk: FAQ_KK,
}


const SettingsLanguage: React.FC<IProps> = ({ $f7router }) => {
  const { i18n } = useTranslation();

  const Body = languageMap[i18n.language];

  return (
    <Page>
      <div className="quiz-top-text-container">
        {
          !aituBridge.isSupported() &&
          <BackButton />
        }
        <span className="quiz-text-primary quiz-font-700">FAQ</span>
        <Body />
      </div>
    </Page>
  );
}

export default SettingsLanguage;
